export default __webpack_public_path__ + "static/media/pare.79294d29.png";